const { NODE_ENV } = process.env
let devUrl = 'http://localhost:5600'
// devUrl = 'https://acadio.dev.diverse.sh'
let prodUrl = 'https://acadio.dev.diverse.sh'
prodUrl = 'https://api.supremeaccess.io'

if (window.location.origin.indexOf('staging') != -1 || window.location.origin.includes('localhost')) {
  prodUrl = 'https://stageapi.supremeaccess.io'
}

devUrl = prodUrl // for now
// prodUrl = devUrl
const API_URL = NODE_ENV == 'development' ? devUrl : prodUrl

const AES_FRONTEND_KEY = '9749aad4edfa6999714b34c8bb57e574635fbb011b258f5e43c666b1a3509e5f'

const STRIPE_DEV = 'pk_test_epVOKsV3SsgKZ80dsmazIN5w'
const STRIPE_PROD = 'pk_live_LK9dLyFD101YFKeltUQ6YARw'

let stripeKey = NODE_ENV == 'development' ? STRIPE_DEV : STRIPE_PROD

export default {
  API_URL,
  AES_FRONTEND_KEY,
  stripeKey,
  intercomId: 'yxcft39z'
}